import { ActionButtons, BigDisplayField, Button, Stack } from '@drycut/ui-components';

import { CouponSummary } from './CouponSummary';

type Props = {
  couponCode: string;
  couponType: string;
  customer?: string;
  onClose: () => void;
};

export function CouponSuccessStep({
  couponCode,
  customer,
  couponType,
  onClose,
}: Props): React.ReactElement {
  return (
    <Stack gap={8} className="px-10">
      <CouponSummary customer={customer} couponType={couponType} />

      <BigDisplayField content={couponCode} />

      <ActionButtons>
        <Button type="button" onClick={onClose}>
          Notieren und schliessen
        </Button>
      </ActionButtons>
    </Stack>
  );
}
